import React, { useState, useEffect } from 'react'
import { Steps, Space} from 'antd'
import { useKPSQspListQuery, useKPSQspjdListQuery } from '../../store/DianShangYeWuApi';
function LoanNodeEdit(props) {
    const [items, setItems] = useState([])
    const {data, isSuccess} = useKPSQspListQuery({kpsq_sp_kpsq_id:props.kpsq_id},{skip:!props.kpsq_id})
    const {data:spjdData, isSuccess:spjdIsSuccess} = useKPSQspjdListQuery({kpsq_spjd_qy_id:props.qy_id,kpsq_spjd_user_id:props.user_id},{skip:!props.user_id});
    useEffect(() => {
        if(isSuccess && data.Status === 'success'){
            const sortedData = [...data.Result].sort((a, b) => {
                return a.kpsq_sp_xuhao - b.kpsq_sp_xuhao;
            })
            const arr = sortedData.map((item) => ({
                title:<span style={{fontSize:"14px",fontWeight:"bold"}}>{item.kpsq_sp_jd_name}</span>       ,
                content:<Space orientation='vertical' size={1}>
                             <span>
                                {(item.kpsq_sp_state==='3' && item.kpsq_sp_jd_name==='抄送') && '已阅读'}
                                {(item.kpsq_sp_state==='3' && item.kpsq_sp_jd_name==='审批') && '已同意'}
                                {(item.kpsq_sp_state==='4' && item.kpsq_sp_jd_name==='审批') && '已驳回'}
                                {item.kpsq_sp_content? '：'+item.kpsq_sp_content :''}
                            </span>
                            <span>{item.kpsq_sp_yh_name} {item.kpsq_sp_state_time} </span>
                        </Space>,
            }))
            setItems([{
                title:<span style={{fontSize:"14px",fontWeight:"bold"}}>创建</span>,
                content:<span style={{fontSize:"12px"}}>{props.kpsq_uname} {props.kpsq_ctime}</span>,
            },
            {
                title:<span style={{fontSize:"14px",fontWeight:"bold"}}>提交</span>,
                content:<span style={{fontSize:"12px"}}>{props.kpsq_uname} {props.kpsq_state_time}</span>,
            },...arr]);
        }else{
            if(spjdIsSuccess && spjdData.Status === 'success'){
                const sortedData = [...spjdData.Result].sort((a, b) => {
                    return a.kpsq_spjd_xuhao - b.kpsq_spjd_xuhao;
                })
                const arr = sortedData.map((item) => ({
                    title:<span style={{fontSize:"14px",fontWeight:"bold"}}>{item.kpsq_spjd_name}</span>       ,
                    content:<span style={{fontSize:"12px"}}>{item.kpsq_spjd_yh_name}</span>,
                }))
                setItems([{
                    title:<span style={{fontSize:"14px",fontWeight:"bold"}}>创建</span>,
                    content:<span style={{fontSize:"12px"}}>{props.kpsq_uname} {props.kpsq_ctime}</span>,
                },
                {
                    title:<span style={{fontSize:"14px",fontWeight:"bold"}}>提交</span>,
                    content:<span style={{fontSize:"12px"}}>{props.kpsq_uname}{props.kpsq_state_time}</span>,
                },...arr]);
            }else{
                setItems([]);
            }
        }
        
        
    },[data, isSuccess,spjdData, spjdIsSuccess,props])
    return (
        <Steps 
            items={items} 
            current={1} 
            size="small" 
            titlePlacement="vertical"
        />
    )
}

export default LoanNodeEdit